import platform from 'rangeConfig/shared/utils/platform';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import openFramesProductListConfig from './productListConfig';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import * as R from 'ramda';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';

const WhiteFramesSwiper = R.pipe(withCategoryFilter(['open-frames-white']));
const AnthraciteFramesSwiper = R.pipe(withCategoryFilter(['open-frames-anthracite']));

const widgets = {
  desktop: [],
  mobile: [
    {
      id: `frame-color-white`,
      component: WhiteFramesSwiper(withProducts(ProductSwiper, openFramesProductListConfig)),
      title: 'storageone.colorWhite',
      iconColor: '#FFFFFF'
    },
    {
      id: `frame-color-anthracite`,
      component: AnthraciteFramesSwiper(withProducts(ProductSwiper, openFramesProductListConfig)),
      title: 'storageone.colorBlack',
      iconColor: '#5D5551'
    }
  ]
};

const mainMenu = {
  menuTitle: 'storageone.openFramesMenuTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: [],
  widgets: widgets[platform]
};

export default mainMenu;
